import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ErrorPage from 'components/Errors/ErrorPage';
import { redirectToLogin } from 'actions/auth/redirectToLogin';
import { timeOutSession } from 'actions/app';

const SessionTimeoutError = ({ intl, dispatch }) => {
  useEffect(() => {
    dispatch(timeOutSession());
  }, []);

  return (
    <ErrorPage
      title={ intl.formatMessage({ id: 'sessionTimeout.page.title' }) }
      showButton
      buttonText={ intl.formatMessage({ id: 'sessionTimeout.page.buttonText' }) }
      onButtonClick={ redirectToLogin }
      type="server"
    >
      <FormattedHTMLMessage id="sessionTimeout.page.content" />
    </ErrorPage>
  );
};

SessionTimeoutError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default injectIntl(connect(
  null,
  mapDispatchToProps
)(SessionTimeoutError));
